import React, {Component} from 'react';
import { Form, Modal } from 'react-bootstrap';
import { IColorStyle } from '../../data/Query';
import ColorSelector from '../ColorSelector';
import MapDWColorPicker from './MapDWColorPicker';
import RangeCtrl from '../charts/RangeCtrl';

class MapStyleDwLayer extends Component<any,any> {
  constructor(props: any) {
    super(props);
    console.log("MapStyleDwLayer() > this.props", this.props);

    this.onSave = this.onSave.bind(this);
    
  }
  // Create an initial color state, allows an actual selection to the color picker upon opening modal
  state = {
    max: null,
    min: null,
    highPoint: this.props.layer ? this.props.layer.dwdataLayerStyle.highRenderedPoint : 8,
    lowPoint: this.props.layer ? this.props.layer.dwdataLayerStyle.lowRenderedPoint : 8,
    highColor: this.props.layer ? this.props.layer.dwdataLayerStyle.highRenderedColor : {} as IColorStyle
  };

  componentDidMount() {
      if(this.props.layer && this.props.layer.dwdataLayerStyle) {
        this.setState({ 
          highPoint: this.props.layer.dwdataLayerStyle.highRenderedPoint,
          lowPoint: this.props.layer.dwdataLayerStyle.lowRenderedPoint,
          highColor: this.props.layer.dwdataLayerStyle.highRenderedColor,
          max: this.props.layer.dwdataLayerStyle.maxVal,
          min: this.props.layer.dwdataLayerStyle.minVal,
        });
      }
  }

  handleSizeChange = (highPoint:any, lowPoint:any) => {
    this.setState({ highPoint, lowPoint });
  };

  handleColorStyleChange(colorStyle: IColorStyle) {
    this.setState({ highColor: colorStyle });
  }

  onSave() {
    if(this.props.saveColor) {
      console.log("121621 this.state.highColor, '', this.state.highPoint, this.state.lowPoint",this.state.highColor, "", this.state.highPoint, this.state.lowPoint); 
      this.props.saveColor(this.state.highColor, "", this.state.highPoint, this.state.lowPoint, this.state.max, this.state.min);
    }
  }
  onRangeUpdate(e:any) {
    console.log("120723 e", e)
    this.setState({ min: e.min });
    this.setState({ max: e.max });
  }

  render() {
    const {min, max} = this.state;
    return (
      <>
        <h5>Display</h5>
        <RangeCtrl
            minTitle="Min Classification Value"
            maxTitle="Max Classification Value"
            min={min ? min : (min == 0) ? min : null} 
            max={max ? max : (max == 0) ? max : null} 
            onUpdate={(e:any) => this.onRangeUpdate(e)} />
        {
        (this.props.definition)
          ? (this.props.definition.feature === 'point')
            ? <Form.Group>
                <Form.Label>Point Size</Form.Label>
                <MapDWColorPicker layer={ this.props.layer } handleChange={ this.handleSizeChange } />
              </Form.Group>
            : ''
          : ''
        }
        <Form.Group>
            <Form.Label>Color Scale</Form.Label>
            <ColorSelector config={this.state.highColor} onUpdate={(e: IColorStyle) => this.handleColorStyleChange(e)}></ColorSelector>
          </Form.Group>
        {/*<Button variant="primary" onClick={this.onSave}>Apply A</Button>*/}
      </>
    );
  }
}
export default MapStyleDwLayer;